/**
 * toggles playing video state, and updates UI
 * @param {HTMLVideoElement} videoElement - The video element to toggle.
**/
export function togglePlaying(videoElement) {
  if (videoElement.style.display==="none") {
    return;
  }
  const iconPlayPause = document.getElementById('iconPlayPause');
  if (videoElement.paused) {
    videoElement.play();
    iconPlayPause.className = "icon-play";
  } else {
    videoElement.pause();
    iconPlayPause.className = "icon-pause";
  }
}